import React from 'react';
import TechMap from '../AccountWorkspace/TechMap';
import { accountKey } from './accountsFormat';

/*
 * AccountsTechmapTab — mounts the existing AccountWorkspace TechMap
 * (the per-user technology-estate canvas) for the selected department,
 * keyed the same way AccountWorkspace mounts it (acronym, falling back
 * to department_id). TechMap owns its own fetch/loading/error states
 * via /api/v1/tech-map/:account.
 */

export default function AccountsTechmapTab({ selectedDepartment }) {
  const account = accountKey(selectedDepartment);
  if (!account) {
    return <p className="accounts-panel-note">Select an agency to see its tech map.</p>;
  }
  return (
    <div className="accounts-techmap-canvas">
      <TechMap account={account} />
    </div>
  );
}
